import Table from '../../components/Table';
import {TabContainer} from './Tab1';

const Tab3 = () => {
  const data = [
    {day: '1', reward: '洗髓经*1', extraReward: '洗髓经*1'},
    {day: '2', reward: '随机饰品礼盒*1', extraReward: '饰品碎片*300'},
    {day: '3', reward: '星玉*100', extraReward: '自选星辰石礼包*1'},
    {
      day: '4',
      reward: '速效150级技能白驹丸*2',
      extraReward: '速效150级技能白驹丸*3'
    },
    {
      day: '5',
      reward: '玄金矿石（特大）*5',
      extraReward: '玄金矿石（特大）*10'
    },
    {day: '6', reward: '真元丹*20', extraReward: '护脉丹*50'},
    {day: '7', reward: '紫蟒碎片*500', extraReward: '紫蟒令*1'},
    {day: '8', reward: '武林秘籍*1', extraReward: '武林秘籍*1'},
    {day: '9', reward: '天赋丹*3', extraReward: '天赋丹*5'},
    {
      day: '10',
      reward: '破碎的宋金功勋章*2',
      extraReward: '破碎的宋金功勋章*3'
    },
    {day: '11', reward: '星玉*100', extraReward: '星玉*200'},
    {
      day: '12',
      reward: '玄金矿石（特大）*5',
      extraReward: '玄金矿石（特大）*10'
    },
    {day: '13', reward: '护脉丹*20', extraReward: '真元丹*50'},
    {day: '14', reward: '黑石*12', extraReward: '黑石*20'},
    {day: '15', reward: '零泣信物*20', extraReward: '名侠简录*3'}
  ];

  const r2 = [
    {
      day: '龙盘紫霄礼-龙',
      reward: '玄猿令*3(7天)',
      rowSpan: 7
    },
    {reward: '神行符*1(30天)'},
    {reward: '无限回城符（无限使用）*1(7天)'},
    {reward: '传声海螺*1(7天)'},
    {reward: '子母袋*1(7天)'},
    {reward: '称号--“龙盘紫霄”[id:539]*1(90天)'},
    {reward: '龙盘紫霄礼-盘*1(7天)'},
    {
      day: '龙盘紫霄礼-盘',
      reward: '玄猿令*4(7天)',
      rowSpan: 4
    },
    {reward: '扩展箱图谱*1(7天)'},
    {reward: '高级寄卖牌*1(7天)'},
    {reward: '龙盘紫霄礼-紫*1(7天)'},
    {
      day: '龙盘紫霄礼-紫',
      reward: '神机值1000点',
      rowSpan: 5
    },
    {reward: '紫蟒令*1(30天)'},
    {reward: '速效技能白驹丸*1(7天)'},
    {reward: '《嫁衣神功-基础篇》*1'},
    {reward: '龙盘紫霄礼-宵*1(15天)'},
    {
      day: '龙盘紫霄礼-宵',
      reward: '剑侠币100万两',
      rowSpan: 8
    },
    {reward: '神机值200点'},
    {reward: '紫蟒令*1(30天)'},
    {reward: '子母袋*3(30天)'},
    {reward: '速效150级技能白驹丸*5(60天)'},
    {reward: '高级派遣令*2(30天)'},
    {reward: '150技能悟性提升50%*1(10天)'},
    {reward: '龙盘紫霄礼Buff*1(90天)'}
  ];

  const r3 = [
    {
      day: '≥100',
      reward: '秘泉之水*10'
    },
    {
      day: '≥1000',
      reward: '秘泉之水*20',
      rowSpan: 2
    },
    {reward: '马牌-沙漠之舟（7天）*1'},
    {
      day: '≥5000',
      reward: '秘泉之水*20',
      rowSpan: 4
    },
    {reward: '月度特权礼包*1'},
    {reward: '功名簿（30天）*20'},
    {reward: '马牌-沙漠之舟（7天）*1'}
  ];

  const open = () => {
    window.open('https://charge.xoyo.com/charge-record');
  };

  return (
    <TabContainer>
      <h3>每日签到 送名侠-零泣</h3>
      <p>
        <span className="bold">活动区服</span>：龙盘紫霄（2010区新服）
      </p>
      <p>
        <span className="bold">活动时间</span>：3月15日-5月15日24：00
      </p>
      <p>
        <span className="bold">礼卡售卖时间</span>：3月15日-5月15日24：00
      </p>
      <p className="bold">活动内容：</p>
      <p>
      武林盟向天下大侠发放“龙盘紫霄·礼”，5月15日前，大侠每日登录游戏，可以通过屏幕右侧活动签到按钮进行签到，领取海量奖励，大侠使用礼卡还可获得额外奖励！
      </p>
      <p className="bold">签到奖励（道具皆为永久绑定）</p>
      <Table
        columns={[
          {title: '天数', key: 'day', width: '14%'},
          {title: '奖励', key: 'reward', width: '38%'},
          {title: '额外奖励', key: 'extraReward', width: '38%'}
        ]}
        data={data}
      />
      <h3>角色预创礼</h3>
      <p>
        <span className="bold">活动区服</span>：龙盘紫霄（2010区新服）
      </p>
      <p>
        <span className="bold">相关NPC</span>：各新手村江湖指引人
      </p>
      <p>
        <span className="bold">预创建时间</span>：即日起至3月15日12点前
      </p>
      <p>
        <span className="bold">领奖时间</span>： 3月15日开服后-5月15日24：00
      </p>
      <p>
        <span className="bold">领奖条件</span>：≥120级
      </p>
      <p className="bold">活动内容:</p>
      <p>（1）即日起至3月15日12点前，大侠可登录新服进行角色预创建。</p>
      <p>
      （2）开服后，大侠可前往江湖接引使处领取真元丹(永久绑定)*10、大真元丹(永久绑定)*2、护脉丹(永久绑定)*10、速效技能白驹丸(永久绑定)*2
      </p>
      <h3>激活码豪礼 领起步装备</h3>
      <p>
        <span className="bold">活动区服</span>：龙盘紫霄（2010区新服）
      </p>
      <p>
        <span className="bold">活动时间</span>：3月15日-5月15日24：00
      </p>
      <p>
        <span className="bold">使用等级</span>：≥135级
      </p>
      <p>
        <span className="bold">相关NPC</span>：各地礼官
      </p>
      <p className="bold">活动内容:</p>
      <p>
      大侠可扫描下方官方服务号二维码，后台回复“龙盘紫霄”，或通过官网首页“新手大礼”→“立即领取”按钮，领取新服专属激活码，于各地礼官处输入激活码，即可获得新服起步好礼！
      </p>
      <img src={require('@/assets/20230912-111813.jpg')} alt="" />
      <p className="bold">礼包内容:</p>
      <Table
        columns={[
          {title: '礼包', key: 'day', width: '30%'},
          {title: '包含道具', key: 'reward', width: '70%'}
        ]}
        data={r2}
      />

      <h3>老玩家回馈 江湖待你回归</h3>
      <p>
        <span className="bold">活动区服</span>：龙盘紫霄（2010区新服）
      </p>
      <p>
        <span className="bold">活动时间</span>：3月15日开服后-5月15日24：00
      </p>
      <p>
        <span className="bold">活动NPC</span>：江湖指引人
      </p>
      <p className="bold">活动内容：</p>
      <p>
      活动内容；
活动期间，根据2010区账号自2010年8月1日-2024年3月1日期间
历史累计充值金额，大侠可在2010区新区【龙盘紫霄】新服开
服后，于新手村江湖接引使处领取1份丰厚的回馈礼包！
<span className="link" onClick={open}>
          点击此处可查看账号充值历史
        </span>
       
        
      </p>
      <p className="bold">回馈奖励：</p>
      <Table
        columns={[
          {title: '历史充值', key: 'day', width: '30%'},
          {title: '奖励道具', key: 'reward', width: '70%'}
        ]}
        data={r3}
      />
    </TabContainer>
  );
};

export default Tab3;
